export const ANIMATION_DURATION = 300
export const DEFAULT_DURATION = 2500
